import { useParams } from 'react-router';

import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { OrganizationDetail } from '../../organizations/components/OrganizationDetail';
import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const PrejimkaOrganizationPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
          resource='Organizations'
          action='update.view'
        >
          <OrganizationDetail organizationId={id} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaOrganizationPage;
